// Application layer
/**
 * Caso de uso: listar inventario
 * ------------------------------------------------
 * Responsabilidad:
 * - Validar filtros
 * - Aplicar reglas de negocio de lectura
 * - Delegar persistencia al repositorio
 */

import { InventarioVentaRepository } from "../infrastructure/supabase/procesarInventariosMovimientos.repository.js";

export async function listarInventarioVentaUseCase(filtros) {
  return await InventarioVentaRepository.listarTotales(filtros);
}
